const summary_cards = [
  { label: 'PACKS IN CYCLE', value: '4', note: 'Board & committees', tone: 'primary' },
  { label: 'READY', value: '1', note: 'Approved to send', tone: 'success' },
  { label: 'IN ASSEMBLY', value: '3', note: 'Being compiled', tone: 'warning' },
  { label: 'FLAGGED SECTIONS', value: '13', note: 'Need attention', tone: 'danger' }
];

const pack_catalog = [
  {
    key: 'board_pack',
    title: 'Board pack',
    subtitle: 'Quarterly - next 28 Jun 2026',
    status: 'In assembly',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    owner: 'Company Secretary',
    action_label: 'Open pack',
    icon: 'bi-file-earmark-text',
    items: [
      { label: 'Compliance health summary', source: 'Command centre', tone: 'success' },
      { label: 'Decisions required', source: 'Reports', tone: 'warning' },
      { label: 'Top risks & movement', source: 'Risks', tone: 'warning' },
      { label: 'POPIA & data privacy', source: 'Data privacy', tone: 'danger' },
      { label: 'Irregular & emergency expenditure', source: 'Exceptions', tone: 'danger' }
    ]
  },
  {
    key: 'audit_committee_pack',
    title: 'Audit committee pack',
    subtitle: 'Quarterly - next 21 Jun 2026',
    status: 'Ready',
    status_class: 'bg-success-subtle text-success-emphasis',
    owner: 'Internal Audit',
    action_label: 'Open pack',
    icon: 'bi-clipboard-check',
    items: [
      { label: 'AGSA readiness', source: 'Audits', tone: 'warning' },
      { label: 'Findings & corrective actions', source: 'Findings & actions', tone: 'warning' },
      { label: 'Evidence completeness', source: 'Evidence vault', tone: 'warning' },
      { label: 'Legal holds & retention', source: 'Records', tone: 'success' }
    ]
  },
  {
    key: 'risk_committee_pack',
    title: 'Risk committee pack',
    subtitle: 'Quarterly - next 24 Jun 2026',
    status: 'In assembly',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    owner: 'CRO',
    action_label: 'Open pack',
    icon: 'bi-shield-exclamation',
    items: [
      { label: 'Risk register & heatmap', source: 'Risks', tone: 'danger' },
      { label: 'Business continuity status', source: 'Continuity', tone: 'warning' },
      { label: 'Health & safety exposures', source: 'HSE', tone: 'warning' },
      { label: 'Insurance & claims', source: 'Insurance', tone: 'success' }
    ]
  },
  {
    key: 'exco_pack',
    title: 'EXCO pack',
    subtitle: 'Monthly - next 02 Jul 2026',
    status: 'Draft',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    owner: 'CEO office',
    action_label: 'Open pack',
    icon: 'bi-briefcase',
    items: [
      { label: 'Operational compliance', source: 'Facilities & HSE', tone: 'warning' },
      { label: 'Service delivery & SLAs', source: 'Service delivery', tone: 'warning' },
      { label: 'Licences & permits expiring', source: 'Licences', tone: 'danger' },
      { label: 'Workforce compliance', source: 'Employees & training', tone: 'success' }
    ]
  }
];

const pack_details = {
  board_pack: {
    title: 'Board pack',
    subtitle: 'Quarterly - next 28 Jun 2026',
    status: 'In assembly',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    meta: [
      { label: '7 sections' },
      { label: '11 decisions to table' },
      { label: '5 recipients' }
    ],
    summary: 'The board pack consolidates governance, risk, evidence and decision items into one board-ready packet.',
    sections: [
      { label: 'Compliance health summary', source: 'Command centre', status: 'Complete', status_class: 'bg-success-subtle text-success-emphasis' },
      { label: 'Decisions required', source: 'Reports', status: 'Open', status_class: 'bg-warning-subtle text-warning-emphasis' },
      { label: 'Top risks & movement', source: 'Risks', status: 'Open', status_class: 'bg-warning-subtle text-warning-emphasis' },
      { label: 'POPIA & data privacy', source: 'Data privacy', status: 'Flagged', status_class: 'bg-danger-subtle text-danger-emphasis' },
      { label: 'Irregular & emergency expenditure', source: 'Exceptions', status: 'Flagged', status_class: 'bg-danger-subtle text-danger-emphasis' }
    ],
    actions: [
      { label: 'Generate PDF', variant: 'primary', icon: 'bi-file-earmark-pdf' },
      { label: 'Download XLSX', variant: 'outline-secondary', icon: 'bi-download' }
    ]
  },
  audit_committee_pack: {
    title: 'Audit committee pack',
    subtitle: 'Quarterly - next 21 Jun 2026',
    status: 'Ready',
    status_class: 'bg-success-subtle text-success-emphasis',
    meta: [
      { label: '5 sections' },
      { label: '7 decisions to table' },
      { label: '5 recipients' }
    ],
    summary: 'The audit committee pack is ready to send and includes AGSA readiness, findings, evidence and records.',
    sections: [
      { label: 'AGSA readiness', source: 'Audits', status: 'Ready', status_class: 'bg-success-subtle text-success-emphasis' },
      { label: 'Findings & corrective actions', source: 'Findings & actions', status: 'Open', status_class: 'bg-warning-subtle text-warning-emphasis' },
      { label: 'Evidence completeness', source: 'Evidence vault', status: 'Open', status_class: 'bg-warning-subtle text-warning-emphasis' },
      { label: 'Legal holds & retention', source: 'Records', status: 'Complete', status_class: 'bg-success-subtle text-success-emphasis' }
    ],
    actions: [
      { label: 'Send pack', variant: 'primary', icon: 'bi-send' },
      { label: 'Preview', variant: 'outline-secondary', icon: 'bi-eye' }
    ]
  },
  risk_committee_pack: {
    title: 'Risk committee pack',
    subtitle: 'Quarterly - next 24 Jun 2026',
    status: 'In assembly',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    meta: [
      { label: '4 sections' },
      { label: '9 decisions to table' },
      { label: '4 recipients' }
    ],
    summary: 'The risk pack is being compiled from live risk movement, continuity, HSE and insurance content.',
    sections: [
      { label: 'Risk register & heatmap', source: 'Risks', status: 'Open', status_class: 'bg-danger-subtle text-danger-emphasis' },
      { label: 'Business continuity status', source: 'Continuity', status: 'Open', status_class: 'bg-warning-subtle text-warning-emphasis' },
      { label: 'Health & safety exposures', source: 'HSE', status: 'Open', status_class: 'bg-warning-subtle text-warning-emphasis' },
      { label: 'Insurance & claims', source: 'Insurance', status: 'Complete', status_class: 'bg-success-subtle text-success-emphasis' }
    ],
    actions: [
      { label: 'Compile pack', variant: 'primary', icon: 'bi-gear' },
      { label: 'Review sections', variant: 'outline-secondary', icon: 'bi-card-list' }
    ]
  },
  exco_pack: {
    title: 'EXCO pack',
    subtitle: 'Monthly - next 02 Jul 2026',
    status: 'Draft',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    meta: [
      { label: '6 sections' },
      { label: '8 decisions to table' },
      { label: '6 recipients' }
    ],
    summary: 'The EXCO pack keeps operational compliance visible, with overdue permits and service issues pulled in from live modules.',
    sections: [
      { label: 'Operational compliance', source: 'Facilities & HSE', status: 'Open', status_class: 'bg-warning-subtle text-warning-emphasis' },
      { label: 'Service delivery & SLAs', source: 'Service delivery', status: 'Open', status_class: 'bg-warning-subtle text-warning-emphasis' },
      { label: 'Licences & permits expiring', source: 'Licences', status: 'Flagged', status_class: 'bg-danger-subtle text-danger-emphasis' },
      { label: 'Workforce compliance', source: 'Employees & training', status: 'Complete', status_class: 'bg-success-subtle text-success-emphasis' }
    ],
    actions: [
      { label: 'Save draft', variant: 'primary', icon: 'bi-save' },
      { label: 'Preview', variant: 'outline-secondary', icon: 'bi-eye' }
    ]
  }
};

export default {
  name: 'BoardAuditPacks',
  data: () => ({
    summary_cards,
    pack_catalog,
    pack_details,
    active_pack_key: 'board_pack'
  }),
  computed: {
    active_pack() {
      return this.pack_details[this.active_pack_key] || null;
    }
  },
  methods: {
    open_pack(pack_key) {
      if (!pack_key || !Reflect.get(this.pack_details, pack_key)) {
        return;
      }

      this.active_pack_key = pack_key;
    },

    new_pack() {
      this.active_pack_key = 'board_pack';
    }
  }
};
